import React from "react";
import Button from "../button";
import A from "../a";
import "./styles.css";

const SecondBanner = ({ premium, loggedIn, signInWithGoogle, user }) => (
  <div className="second-banner" id="pricing">
    <div className="text-button">
      <h3>What are you waiting for?</h3>
      {!loggedIn ? (
        <p>Get Ghast to upgrade your connection for minecraft!</p>
      ) : !premium ? (
        <p>
          Buy Ghast for
          {/* <span style={{ textDecoration: "line-through", paddingRight: "1px" }}>
            $15
          </span>{" "} */}
          {/* <span
            style={{
              textDecoration: "line-through",
              paddingRight: "5px"
            }}
          >
            $15
          </span> */}
          $15 to upgrade your connection now, 7 day money back guarantee in case
          you change your mind!
        </p>
      ) : (
        <p>Thank you for supporting Ghast, download link below!</p>
      )}

      {!loggedIn ? (
        <div className="paypal-button">
          <A onClick={signInWithGoogle}>
            <Button>GET STARTED</Button>
          </A>
        </div>
      ) : (
        <div>
          {premium ? (
            <div className="paypal-button">
              <A href="/download">
                <Button>DOWNLOAD</Button>
              </A>
            </div>
          ) : (
            <div className="paypal-button">
              <A href="/checkout">
                <Button>BUY NOW</Button>
              </A>
            </div>
          )}
        </div>
      )}

      {/* <h2>$15</h2> */}
    </div>
  </div>
);

export default SecondBanner;



/** WEBPACK FOOTER **
 ** ./src/views/components/secondBanner/index.js
 **/